import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { API_URLS } from '../../../../environments/env-routes';
import { APIHelper } from '../../../../shared/services/api-helper/api-helper.service';
import { UserService } from '../../../../shared/services/user/user.service';
import { NodesService } from '../+sites/document-library/shared/services/nodes.service';
import { SiteService } from '../shared/services/site.service';
import { DialogCreateSiteComponent } from './shared/components/dialog-create-site/dialog-create-site.component';
import { StorageService } from 'src/shared/services/storage/storage.service';

@Component({
  selector: 'app-view-sites',
  templateUrl: './view-sites.component.html',
  styleUrls: ['./view-sites.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {class: 'app-view-sites'}
})
export class ViewSitesComponent implements OnInit {
  public loadingPage: boolean;
  public messages: Object;
  public valueSearchSite = '';
  public user: any;
  getRowClass = row => {
    return {
      isSelected: this.nodeService.rootSite === row.entry.id
    };
  };
  @Output() private selectSite = new EventEmitter();

  constructor(
    private api: APIHelper,
    private router: Router,
    private nodeService: NodesService,
    private dialog: MatDialog,
    public userService: UserService,
    public siteService: SiteService,
    private storage: StorageService
  ) {
  }

  ngOnInit() {
    this.loadingPage = true;

    this.messages = {
      emptyMessage: '<p>Aucun dossier</p>'
    };
    this.userService.getCurrentUser().then((res) => {


    });
    this.initialize();
  }

  public createSite() {
    const dialogRef = this.dialog.open(DialogCreateSiteComponent, {
      width: '60%',
      height: '50%'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
       
        const newEntry: any = {entry: {...result, site: result}};
        this.siteService.sites = [...this.siteService.sites, newEntry];
      }
    });
  }

  goToSite(id, site, siteId) {
    if (this.loadingPage) {
      return;
    }

    const queries =
      'include=path,properties,allowableOperations,permissions&relativePath=/documentLibrary';

    this.loadingPage = true;
    this.api
      .requestApi({
        action: API_URLS.nodes.nodes.replace(':nodeId', id),
        queryArgs: queries
      })
      .then(res => {
        this.siteService.siteId = siteId;
    
        this.userService.setRoleSite(site.role);

        this.router.navigate(['/', 'home', 'my-libraries', 'sites', siteId, 'lib', res.id]);

        this.selectSite.emit();
        // this.siteService.isOpen = true;
      })
      .finally(() => (this.loadingPage = false));
  }

  onSelect({selected}) {
  }

  onActivate(event) {
    if (event.type === 'click') {
      this.goToSite(event.row.entry.guid, event.row.entry, event.row.entry.id);
      this.nodeService.rootSite = event.row.entry.id;
    }
  }

  public goToSiteSettings(event, id) {
    
    event.stopPropagation();
    this.router.navigate(['/', 'home', 'my-libraries', 'sites', id, 'dashboard']);
  }

  private initialize() {
    this.nodeService
      .getSites()
      .then(res => {
        this.siteService.sites = res.list.entries;
      })
      .finally(() => (this.loadingPage = false));
  }
}
